import $ from 'jquery';
import {getAppName} from "util/AppName";
import _ from 'lodash';

const appName = getAppName();
if (!appName) {
	console.error("No application name defined");
} else {
	$(document).ajaxSend(function (event, jqXHR) {
		jqXHR.setRequestHeader('sisAppName', appName);
	});
}
$.ajaxSetup({cache: false});

$(document).ajaxError(function (event, jqxhr, settings, thrownError) {
	if (jqxhr.status == 403) {
		// alert("Sorry, your session has expired. Please login again to continue");
		window.location.reload();
	}
});


window.sis = {
	...window.sis,
	$,
};